import { render, staticRenderFns } from "./StatementEnableService.vue?vue&type=template&id=a58d0200&"
import script from "./StatementEnableService.vue?vue&type=script&lang=js&"
export * from "./StatementEnableService.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports